export default __webpack_public_path__ + "static/media/icons8-image.7a536e62.svg";